export var requiredParam = function requiredParam(param) {
  var requiredParamError = new Error('Required parameter, "' + param + '" is missing.');

  // preserve original stack trace
  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(requiredParamError, requiredParam);
  }

  throw requiredParamError;
};